import { RegionAPI } from '../../../api/bussched/RegionAPI';

const ERR_MSG = "Ocorreu um erro a ler as Regiões";

export class RegionsCommand {
    list(successCallback, errorCallback) {
        const apiResult = RegionAPI.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback(ERR_MSG);
            }
        });
    }
}
